export const USER_ROLES = {
    TENANT: "TENANT",
    OWNER: "OWNER",
}